import { request } from "../axios/request";

export const getZonesService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/zones", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const getAllZonesService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/zones", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveZoneService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/zones/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/zones", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteZoneService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/zones/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};
